import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useCourseCore } from '../modules/course';
import { CourseTheme, getBrandedCourseTheme } from '../constants/courses';

const COURSE_PATH = /\/me\/courses?\/(\d+)/;

/**
 * Color (y logo, si tiene) del curso en el que está el alumno.
 * Devuelve null fuera de un curso o en cursos sin color propio: ahí cada pantalla usa su morado de siempre.
 * En el Inicio aplica al curso elegido en el selector.
 */
const useCourseTheme = (): CourseTheme | null => {
  const { pathname } = useLocation();
  const { course } = useCourseCore();

  return useMemo(() => {
    const fromPath = pathname.match(COURSE_PATH)?.[1];
    const id = fromPath ?? (pathname.endsWith('/inicio') && course ? String(course.id) : undefined);
    if (!id) return null;
    return getBrandedCourseTheme({ id });
  }, [course, pathname]);
};

export default useCourseTheme;
